import { render, staticRenderFns } from "./ErrorField.vue?vue&type=template&id=864bab5a&scoped=true&"
import script from "./ErrorField.vue?vue&type=script&lang=js&"
export * from "./ErrorField.vue?vue&type=script&lang=js&"
import style0 from "./ErrorField.vue?vue&type=style&index=0&id=864bab5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864bab5a",
  null
  
)

export default component.exports